import { http } from '@/http';
import { OnboardingData, OnboardingResponse } from './data-enrichment';

export const newCertificate = (onboardingData: OnboardingData) => {
	return http.post<OnboardingResponse>(
		'v2/onboarding/new-certificate',
		onboardingData,
	);
};
